import type { SVGProps } from 'react'
const SvgSyExchangeVertical = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path d="M10,20.3l4.4-4.4,1.1,1.1-6.3,6.3-6.3-6.3,1.1-1.1,4.4,4.4v-10.7h1.6s0,10.6,0,10.6Z" />
		<path d="M15.6,3.7l4.4,4.4,1.1-1.1L14.8.6l-6.3,6.3,1.1,1.1,4.4-4.4v10.7h1.6s0-10.6,0-10.6Z" />
	</svg>
)
export default SvgSyExchangeVertical
